import { useEffect, useState } from 'react';

const SHORT_MS = 180;
const MEDIUM_MS = 300;

function useAnimatedPresence(open, duration = MEDIUM_MS) {
  const [render, setRender] = useState(open);
  const [visible, setVisible] = useState(open);

  useEffect(() => {
    if (open) {
      setRender(true);
      const frame = requestAnimationFrame(() => {
        requestAnimationFrame(() => { setVisible(true); });
      });
      return () => { cancelAnimationFrame(frame); };
    }
    setVisible(false);
    const timer = window.setTimeout(() => { setRender(false); }, duration);
    return () => { window.clearTimeout(timer); };
  }, [open, duration]);

  return { render, visible };
}

export function AnimatedPopover({
  open, children, className = '', style, align = 'right',
}) {
  const { render, visible } = useAnimatedPresence(open, SHORT_MS);
  if (!render) { return null; }
  const alignClass = align === 'left' ? 'cc-ai-popover-left' : 'cc-ai-popover-right';
  return (
    <div
      className={`cc-ai-popover ${alignClass} ${visible ? 'cc-ai-popover-open' : 'cc-ai-popover-closed'} ${className}`}
      style={style}
      aria-hidden={!open}
    >
      {children}
    </div>
  );
}

export function AnimatedCollapse({ open, children, className = '' }) {
  const { render, visible } = useAnimatedPresence(open, MEDIUM_MS);
  if (!render) { return null; }
  return (
    <div className={`cc-ai-collapse ${visible ? 'cc-ai-collapse-open' : 'cc-ai-collapse-closed'} ${className}`}>
      <div className="cc-ai-collapse-inner">{children}</div>
    </div>
  );
}
